// import { useState, useEffect, useCallback, useRef } from 'react';
// import axios from 'axios';
// import { Link, useLocation } from 'react-router-dom';
// import { Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip, Card, CardContent, Checkbox, useMediaQuery, useTheme, CircularProgress, TextField, InputAdornment, Dialog, Button, DialogTitle, DialogContent, DialogActions, DialogContentText, } from '@mui/material';
// import { VscNewFile } from "react-icons/vsc";
// import { FaFileExcel } from 'react-icons/fa';
// import DeleteIcon from '@mui/icons-material/Delete';
// import SearchIcon from '@mui/icons-material/Search';
// import { useAuth } from '../context/AuthContext';
// import CommonServerDataGrid from '../components/datagridComponent';
// import { formatRows } from '../utils/formatRows';
// import NoDataComponent from '../components/NoDataComponent';
// import CenterLoader from './Test/components/CenterLoader';
// import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
// import { APPBAR_HEIGHT } from '../utils/theme';

// /**
//  * CurrencyDetail2 Component
//  * 
//  * Displays currencies in two views:
//  * - Desktop: CommonServerDataGrid with pagination, filtering, sorting
//  * - Mobile: Card view with search and pagination
//  * 
//  * Features:
//  * - Server-side pagination, filtering, sorting
//  * - Search functionality for mobile view
//  * - Bulk deletion
//  * - Excel export
//  * - Responsive design
//  */
// export default function CurrencyDetail2({ connectionString }) {
//     const { user, selectedCompany } = useAuth();
//     const API = `${connectionString}/currencymaster`;
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory;

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
//     const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));


//     // ============ STATE MANAGEMENT ============

//     // Shared state for both views
//     const [rows, setRows] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//     const [selectAll, setSelectAll] = useState(false);

//     // Desktop state (DataGrid)
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [filterModel, setFilterModel] = useState({ items: [] });
//     const [sortModel, setSortModel] = useState([]);
//     const [isFiltered, setIsFiltered] = useState(false);

//     // Mobile state (Search + Pagination)
//     const [mobileSearchQuery, setMobileSearchQuery] = useState('');
//     const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
//     const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });
//     // const location = useLocation();

//     const [confirmOpen, setConfirmOpen] = useState(false);
//     const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
//     const selectedIdsRef = useRef([]);

//     // ============ PARAMETER BUILDERS ============

//     /**
//      * Build parameters for mobile search request
//      */
//     const buildMobileParams = (pageNum, searchText) => {
//         const offset = pageNum * 20;
//         const params = {
//             mode: 'search',
//             companyId,
//             userId,
//             offset,
//             limit: 20
//         };

//         if (searchText && searchText.trim()) {
//             params.search = searchText; // Send search to backend
//         }

//         console.log('📦 buildMobileParams:', params);
//         return params;
//     };

//     /**
//      * Build parameters for desktop request with filters and sort
//      */
//     const buildDesktopParams = (pageNum, pageSize) => {
//         const offset = pageNum * pageSize;
//         const params = {
//             mode: 'search',
//             companyId,
//             userId,
//             offset,
//             limit: pageSize
//         };

//         // Add filters from DataGrid
//         filterModel.items.forEach(item => {
//             if (item.value) {
//                 switch (item.field) {
//                     case 'CurrencyName':
//                         params.CurrencyName = item.value;
//                         break;
//                     case 'CurrencySymbol':
//                         params.CurrencySymbol = item.value;
//                         break;
//                     default:
//                         break;
//                 }
//             }
//         });

//         // Add sorting
//         if (sortModel.length > 0) {
//             const sort = sortModel[0];
//             params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
//         }

//         console.log('🖥️ buildDesktopParams:', params);
//         return params;
//     };

//     // ============ FETCH FUNCTIONS ============

//     /**
//      * Fetch data for desktop view (with filters and sort)
//      */
//     const fetchDataDesktop = useCallback(async () => {
//         if (isSmallScreen) return;

//         console.log('🖥️ [DESKTOP] Fetching data...');
//         setLoading(true);
//         try {
//             const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

//             // Fetch rows
//             const dataRes = await axios.get(`${API}/search`, { params });
//             const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
//             setRows(formatRows(fetchedRows));
//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             console.log(`🖥️ Fetched ${fetchedRows.length} rows`);

//             // Fetch total count
//             const countParams = { ...params };
//             delete countParams.mode;
//             delete countParams.offset;
//             delete countParams.limit;
//             delete countParams.orderBy;
//             delete countParams.userId;

//             const countRes = await axios.get(`${API}/count`, { params: countParams });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);

//             console.log(`🖥️ Total count: ${count}`);
//         } catch (err) {
//             console.error('🖥️ Fetch error:', err);
//             setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
//             setRows([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [API, companyId, userId, paginationModel, filterModel, sortModel, isSmallScreen]);

//     /**
//      * Fetch data for mobile view (with search only)
//      */
//     const fetchDataMobile = useCallback(async () => {
//         console.log('📱 [MOBILE] Fetching data...');

//         if (!isSmallScreen) {
//             console.log('📱 Skipping - not small screen');
//             return;
//         }

//         setLoading(true);
//         try {
//             const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

//             console.log('📱 API URL:', `${API}/search`);
//             console.log('📱 Params:', JSON.stringify(params, null, 2));

//             // Fetch rows
//             const dataRes = await axios.get(`${API}/search`, { params });
//             const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
//             setRows(formatRows(fetchedRows));
//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             console.log(`📱 Fetched ${fetchedRows.length} rows`);

//             // Fetch total count
//             const countParams = { ...params };
//             delete countParams.mode;
//             delete countParams.offset;
//             delete countParams.limit;
//             delete countParams.userId;

//             console.log('📱 Count params:', countParams);
//             const countRes = await axios.get(`${API}/count`, { params: countParams });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);

//             console.log(`📱 Total count: ${count}`);
//         } catch (err) {
//             console.error('📱 Fetch error:', err);
//             console.error('📱 Error response:', err.response?.data);
//             setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
//             setRows([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [API, companyId, userId, mobilePaginationModel, debouncedMobileSearch, isSmallScreen]);

//     // ============ EFFECTS ============

//     /**
//      * Trigger desktop fetch when pagination, filters, or sort changes
//      */
//     useEffect(() => {
//         console.log('💻 [EFFECT] Desktop dependencies changed');
//         if (!isSmallScreen) {
//             fetchDataDesktop();
//         }
//     }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isSmallScreen, fetchDataDesktop]);

//     /**
//      * Trigger mobile fetch when pagination changes
//      */
//     useEffect(() => {
//         console.log('📱 [EFFECT] Mobile pagination changed:', mobilePaginationModel);
//         if (isSmallScreen) {
//             fetchDataMobile();
//         }
//     }, [mobilePaginationModel.page, mobilePaginationModel.pageSize, isSmallScreen, debouncedMobileSearch]);

//     /**
//      * Debounce mobile search and trigger fetch
//      */
//     useEffect(() => {
//         console.log('⏱️ [DEBOUNCE] Starting 400ms timeout for:', mobileSearchQuery);

//         const timer = setTimeout(() => {
//             console.log('⏱️ [DEBOUNCE] Timer completed! Setting search to:', mobileSearchQuery);
//             setDebouncedMobileSearch(mobileSearchQuery);
//             setMobilePaginationModel({ page: 0, pageSize: 20 });
//         }, 400);

//         return () => {
//             console.log('⏱️ [DEBOUNCE] Cleared timeout');
//             clearTimeout(timer);
//         };
//     }, [mobileSearchQuery]);

//     // ============ DELETE HANDLER ============

//     const getCurrencyNameById = (id) => {
//         const row = rows.find(r => Number(r.CurrencyId) === Number(id));
//         console.log("row", row)
//         return row?.CurrencyName || `ID ${id}`;
//     };

//     const handleDeleteMulti = async () => {
//         const ids = selectedIdsRef.current;
//         if (!ids.length) return;

//         try {
//             const response = await axios.post(`${API}/Delete`, {
//                 companyId,
//                 userId,
//                 objAryId: ids
//             });

//             console.log("Delete API response:", response);
//             setSnackbar({
//                 open: true,
//                 message: 'Deleted successfully.',
//                 severity: 'success'
//             });

//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             setSelectAll(false);

//             // Refetch data
//             if (isSmallScreen) {
//                 fetchDataMobile();

//             } else {
//                 fetchDataDesktop();
//             }
//         } catch (error) {
//             const status = error.response?.status;
//             const data = error.response?.data;
//             // 🔴 Case: 400 + referenced IDs (business rule failure)
//             if (status === 400 && data?.referencedIds?.length > 0) {
//                 setSnackbar({
//                     open: true,
//                     message: "Cannot delete the selected item(s) because they are referenced in other records.",
//                     severity: "warning"
//                 });

//             } else if (status === 400 && data?.error) {
//                 // 🔴 400 but no referencedIds array (generic validation)
//                 setSnackbar({
//                     open: true,
//                     message: data.error,
//                     severity: "warning"
//                 });
//             } else {
//                 // 🔴 unexpected / server error
//                 setSnackbar({
//                     open: true,
//                     message: "Delete failed due to an unexpected error.",
//                     severity: "error"
//                 });
//             }
//         } finally {
//             setConfirmOpen(false);
//         }
//     };

//     // ============ EXPORT HANDLER ============

//     const funExportData = () => {
//         axios({
//             url: `${API}/search?mode=export&companyId=${companyId}&userId=${userId}`,
//             method: 'GET',
//             responseType: 'blob',
//         })
//             .then((response) => {
//                 const url = window.URL.createObjectURL(new Blob([response.data]));
//                 const link = document.createElement('a');
//                 link.href = url;
//                 link.setAttribute('download', 'exportedFileCurrency.xlsx');
//                 document.body.appendChild(link);
//                 link.click();
//                 link.remove();
//             })
//             .catch((error) => {
//                 console.error('Export error:', error);
//                 setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
//             });
//     };

//     // ============ SELECT ALL TOGGLE ============

//     const toggleSelectAll = () => {
//         if (selectAll) {
//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             setSelectAll(false);
//         } else {
//             const allIds = rows.map(row => row.CurrencyId);
//             setSelectionModel(allIds);
//             selectedIdsRef.current = allIds; // 🔥 freeze
//             setSelectAll(true);
//         }
//     };

//     // ============ COLUMNS DEFINITION ============

//     const columns = [
//         { field: 'CurrencyName', headerName: 'Currency Name', flex: 1, minWidth: 150,
//             renderCell: (params) => (
//                 <Typography
//                     variant="body1"
//                     sx={{
//                         cursor: 'pointer',
//                         color: '#1877F2',
//                         textDecoration: 'underline',
//                         fontSize: '0.85rem'
//                     }}
//                     onClick={() => window.location.href = `/main/editCurrencyMaster/${params.row.CurrencyId}`}
//                 >
//                     {params.value}
//                 </Typography>
//             )
//         },
//         { field: 'CurrencySymbol', headerName: 'Symbol', flex: 0.5, minWidth: 100,
//             renderCell: (params) => (
//                 <Typography variant="body2" color="text.secondary">
//                     {params.value || '—'}
//                 </Typography>
//             )
//         },
//     ];

//     // Add delete button column if not User
//     if (role !== "User") {
//         columns.push({
//             flex: 0.3,
//             minWidth: 80,
//             sortable: false,
//             filterable: false,
//             headerAlign: 'center',
//             align: "center",
//             renderCell: (params) => {
//                 const isRowSelected = selectionModel.includes(params.row.CurrencyId);
//                 return (
//                     <Tooltip title={isRowSelected ? "Delete Selected" : "Select row to enable"}>
//                         <span>
//                             <IconButton
//                                 color="error"
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     e.preventDefault();
//                                     selectedIdsRef.current = selectionModel;   // 🔥 SYNC HERE
//                                     setPendingDeleteIds(selectionModel);
//                                     setConfirmOpen(true);

//                                 }}
//                                 disabled={!isRowSelected}
//                             >
//                                 <DeleteIcon />
//                             </IconButton>
//                         </span>
//                     </Tooltip>
//                 );
//             }
//         });
//     }

//     // ============ CARD RENDERING (MOBILE) ============

//     const renderCards = () => {
//         if (loading) {
//             return (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
//                     <CircularProgress />
//                 </Box>
//             );
//         }

//         if (rows.length === 0) {
//             return (
//                 <Box sx={{ p: 4, textAlign: 'center' }}>
//                     <Typography sx={{ color: 'text.secondary', mb: 2 }}>
//                         {mobileSearchQuery ? <CustomNoDataOverlay /> : <NoDataComponent />}
//                     </Typography>
//                     <Typography sx={{ color: 'text.secondary', fontSize: '0.85rem' }}>
//                         Search: "{debouncedMobileSearch}" | Page: {mobilePaginationModel.page} | Total: {totalCount}
//                     </Typography>
//                 </Box>
//             );
//         }

//         return (
//             <>
//                 {rows.map((row) => {
//                     const isSelected = selectionModel.includes(row.CurrencyId);

//                     const toggleSelection = (e) => {
//                         e.stopPropagation();
//                         setSelectionModel(prev => {
//                             const updated = prev.includes(row.CurrencyId)
//                                 ? prev.filter(id => id !== row.CurrencyId)
//                                 : [...prev, row.CurrencyId]
//                             selectedIdsRef.current = updated; // 🔥 freeze selection
//                             return updated;
//                         }
//                         );

//                     };

//                     return (
//                         <Card
//                             key={row.CurrencyId}
//                             sx={{ mb: 1.5, boxShadow: 3, borderRadius: 2, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 5 }, borderLeft: '4px solid', borderLeftColor: 'primary.main', cursor: 'pointer' }}
//                             onClick={() => window.location.href = `/main/editCurrencyMaster/${row.CurrencyId}`}
//                         >
//                             <CardContent sx={{ py: 1.8, px: 2, pb: '14px !important' }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                                     {/* Checkbox */}
//                                     {role !== 'User' && (
//                                         <Checkbox checked={isSelected} onChange={toggleSelection} onClick={(e) => e.stopPropagation()} size="small" sx={{ p: 0.5 }} />
//                                     )}

//                                     {/* Currency Name - Left Side */}
//                                     <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 600, fontSize: { xs: '1rem', sm: '1.1rem' }, flex: 0 }} > {row.CurrencyName || '—'} </Typography>

//                                     {/* Spacer - Pushes symbol to right */}
//                                     <Box sx={{ flex: 1 }} />  {/* ⭐ Takes all remaining space */}

//                                     {/* Currency Symbol - Right Side */}
//                                     <Typography variant="body1" color="text.secondary" sx={{ flex: 0, whiteSpace: 'nowrap' }} > {row.CurrencySymbol || '—'} </Typography>
//                                 </Box>
//                             </CardContent>
//                         </Card>
//                     );
//                 })}

//                 {/* Mobile Pagination Controls */}
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 2, mt: 2 }}>
//                     <button onClick={() => setMobilePaginationModel(p => ({ ...p, page: Math.max(0, p.page - 1) }))} disabled={mobilePaginationModel.page === 0} style={{ padding: '8px 12px', cursor: mobilePaginationModel.page === 0 ? 'not-allowed' : 'pointer', opacity: mobilePaginationModel.page === 0 ? 0.5 : 1, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5', }} > ← Previous </button>

//                     <Typography variant="body2" sx={{ minWidth: '150px', textAlign: 'center' }}>
//                         Page {mobilePaginationModel.page + 1} of {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
//                     </Typography>

//                     <button onClick={() => setMobilePaginationModel(p => ({ ...p, page: p.page + 1 }))} disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount} style={{ padding: '8px 12px', cursor: (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount ? 'not-allowed' : 'pointer', opacity: (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount ? 0.5 : 1, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5', }} > Next → </button>
//                 </Box>
//             </>
//         );
//     };

//     // ============ RENDER ============

//     return (
//         <Box sx={{
//             pt: 0.7, px: { xs: 2, sm: 3, md: 4 }, display: 'flex',
//             flexDirection: 'column', height: `calc(100vh - ${APPBAR_HEIGHT}px)`,
//         }}>
//             {/* Toolbar */}
//             <Box sx={{ position: 'relative', mb: 0.7 }}>
//                 {/* Icons - Absolute positioned on the left */}
//                 <Box sx={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: 0.3, zIndex: 1 }}>
//                     <Tooltip title="Add New Currency">
//                         <IconButton component={Link} to="/main/currencyMaster" sx={{ color: "orange" }}>
//                             <VscNewFile size={25} />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Export to Excel">
//                         <IconButton onClick={funExportData} color="success">
//                             <FaFileExcel size={22} />
//                         </IconButton>
//                     </Tooltip>
//                 </Box>

//                 {/* Title - Centered */}
//                 <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600 }} >
//                     {isSmallDevice ? "Currency" : "Currency Details"}
//                 </Typography>

//             </Box>

//             {/* Content */}
//             <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, marginBottom: "12px" }}>
//                 <Box sx={{ p: { xs: 0.5, md: 0.5 }, display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
//                     {/* Mobile Search Field */}
//                     {isSmallScreen && (
//                         <Box sx={{ mb: 2, px: 1 }}>
//                             <TextField fullWidth size="small" placeholder="Search currencies..." value={mobileSearchQuery} onChange={(e) => setMobileSearchQuery(e.target.value)}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Box>
//                     )}

//                     {/* Bulk Action Bar - Mobile Only */}
//                     {isSmallScreen && role !== 'User' && selectionModel.length > 0 && (
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }} >
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
//                                 <Typography variant="body2" sx={{ ml: 1 }}>
//                                     {selectionModel.length} selected
//                                 </Typography>
//                             </Box>
//                             <Tooltip title="Delete selected">
//                                 <IconButton onClick={(e) => {
//                                     e.stopPropagation();
//                                     e.preventDefault();
//                                     selectedIdsRef.current = selectionModel;   // 🔥 SYNC HERE
//                                     setPendingDeleteIds(selectionModel);
//                                     setConfirmOpen(true);
//                                 }}
//                                     color="error">
//                                     <DeleteIcon />
//                                 </IconButton>
//                             </Tooltip>
//                         </Box>
//                     )}

//                     {/* Mobile View - Cards */}
//                     {isSmallScreen ? (
//                         <Box sx={{ width: '100%', overflowX: 'hidden', px: 1, flex: 1, overflowY: 'auto' }}>
//                             {renderCards()}
//                         </Box>
//                     ) : (
//                         /* Desktop View - CommonServerDataGrid */

//                         <Box sx={{ flex: 1, width: '100%', minHeight: 0 }}>
//                             {
//                                 rows?.length === 0 && !isFiltered ? (
//                                     <NoDataComponent />
//                                 ) : (
//                                     <CommonServerDataGrid
//                                         data={rows}
//                                         columns={columns}
//                                         getRowId={(row) => row.CurrencyId}
//                                         role={role}
//                                         pageSizeOptions={[25, 50, 100]}
//                                         selectionModel={selectionModel}
//                                         onSelectionModelChange={setSelectionModel}
//                                         onPageChange={({ page, pageSize }) => {
//                                             setPaginationModel({ page, pageSize });
//                                         }}
//                                         onFilterChange={setFilterModel}
//                                         onSortChange={setSortModel}
//                                         rowCount={totalCount}
//                                         onFilterStatusChange={setIsFiltered}
//                                     />
//                                 )
//                             }

//                         </Box>
//                     )}
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} sx={{ whiteSpace: "pre-line" }} >
//                 <Alert severity={snackbar.severity} variant="filled">
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>

//             <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth >
//                 <DialogTitle>Confirm Deletion</DialogTitle>

//                 <DialogContent>
//                     <Typography variant="body2">
//                         Are you sure you want to delete{' '}
//                         <strong>{pendingDeleteIds.length}</strong> HSN record(s)?
//                     </Typography>
//                 </DialogContent>

//                 <DialogActions>
//                     <Button onClick={() => setConfirmOpen(false)} variant='outlined'>
//                         Cancel
//                     </Button>

//                     <Button color="error" variant="contained" onClick={handleDeleteMulti} >
//                         Delete
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </Box>
//     );
// }







import { useState, useEffect, useRef } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Avatar,
    Chip,
    Divider,
    CircularProgress,
    IconButton,
    Tooltip,
    Dialog,
    Paper,
    Snackbar,
    Alert,
    DialogContent,
    Typography,
    Checkbox,
    InputAdornment,
    TextField
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
import NoDataComponent from '../components/NoDataComponent';
import { useTheme, useMediaQuery } from '@mui/material';
import CommonServerDataGrid from '../components/datagridComponent';
import { formatRows } from '../utils/formatRows';
import { VscNewFile } from "react-icons/vsc";
import { FaFileExcel } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { APPBAR_HEIGHT } from '../utils/theme';
import CurrencyMaster from './CurrencyMaster';

function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}
function getInitials(name) {
    if (!name) return 'C';
    return name.trim().charAt(0).toUpperCase();
}

// ── CurrencyDetail2 ───────────────────────────────────────────────────────────
// Lists all currency configurations for the company (e.g., INR, USD, EUR).
// Used in invoices and orders to support multi-currency transactions.
const CurrencyDetail2 = ({ connectionString, companyId, mode, setMode }) => {
    const navigate = useNavigate();
    const { user, selectedCompany } = useAuth();
    const API = `${connectionString}/currencymaster`;
    const userId = user?.UserId || null;
    const role = user?.UserCategory;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));

    // ================= STATE =================
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Dialog control
    const [openDialog, setOpenDialog] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [selectionModel, setSelectionModel] = useState([]);
    const selectedIdsRef = useRef([]);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingDeleteIds, setPendingDeleteIds] = useState([]);

    // Mobile Search & Pagination
    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
    const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });
    const [selectAll, setSelectAll] = useState(false);

    // Desktop Pagination & Filtering
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [sortModel, setSortModel] = useState([]);
    const [isFiltered, setIsFiltered] = useState(false);

    const [totalCount, setTotalCount] = useState(0);

    // ================= PARAMETER BUILDERS =================

    /**
     * Build parameters for mobile search request
     */
    const buildMobileParams = (pageNum, searchText) => {
        const offset = pageNum * 20;
        const params = {
            mode: 'search',
            companyId,
            userId,
            offset,
            limit: 20
        };

        if (searchText && searchText.trim()) {
            params.search = searchText;
        }

        console.log('📦 buildMobileParams:', params);
        return params;
    };

    /**
     * Build parameters for desktop request with filters and sort
     */
    const buildDesktopParams = (pageNum, pageSize) => {
        const offset = pageNum * pageSize;
        const params = {
            mode: 'search',
            companyId,
            userId,
            offset,
            limit: pageSize
        };

        // Add filters from DataGrid
        filterModel.items.forEach(item => {
            if (item.value) {
                switch (item.field) {
                    case 'CurrencyName':
                        params.CurrencyName = item.value;
                        break;
                    case 'CurrencySymbol':
                        params.CurrencySymbol = item.value;
                        break;
                    default:
                        break;
                }
            }
        });

        // Add sorting
        if (sortModel.length > 0) {
            const sort = sortModel[0];
            params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
        }

        console.log('🖥️ buildDesktopParams:', params);
        return params;
    };

    // ================= FETCH FUNCTIONS =================

    /**
     * Fetch data for mobile view (with search only)
     */
    const fetchDataMobile = async () => {
        console.log('📱 [MOBILE] Fetching data...');

        if (!isMobile) {
            console.log('📱 Skipping - not mobile screen');
            return;
        }

        setLoading(true);
        try {
            const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

            console.log('📱 API URL:', `${API}/search`);
            console.log('📱 Params:', JSON.stringify(params, null, 2));

            // Fetch rows
            const dataRes = await axios.get(`${API}/search`, { params });
            const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
            setData(formatRows(fetchedRows));
            setSelectionModel([]);
            selectedIdsRef.current = [];
            console.log(`📱 Fetched ${fetchedRows.length} rows`);

            // Fetch total count
            const countParams = { ...params };
            delete countParams.mode;
            delete countParams.offset;
            delete countParams.limit;
            delete countParams.userId;

            console.log('📱 Count params:', countParams);
            const countRes = await axios.get(`${API}/count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);

            console.log(`📱 Total count: ${count}`);
        } catch (err) {
            console.error('📱 Fetch error:', err);
            console.error('📱 Error response:', err.response?.data);
            setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
            setData([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    };

    /**
     * Fetch data for desktop view (with filters and sort)
     */
    const fetchDataDesktop = async () => {
        if (isMobile) return;

        console.log('🖥️ [DESKTOP] Fetching data...');
        setLoading(true);
        try {
            const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

            // Fetch rows
            const dataRes = await axios.get(`${API}/search`, { params });
            const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
            setData(formatRows(fetchedRows));
            setSelectionModel([]);
            selectedIdsRef.current = [];
            console.log(`🖥️ Fetched ${fetchedRows.length} rows`);

            // Fetch total count
            const countParams = { ...params };
            delete countParams.mode;
            delete countParams.offset;
            delete countParams.limit;
            delete countParams.orderBy;
            delete countParams.userId;

            const countRes = await axios.get(`${API}/count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);

            console.log(`🖥️ Total count: ${count}`);
        } catch (err) {
            console.error('🖥️ Fetch error:', err);
            setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
            setData([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    };

    // ================= EFFECTS =================

    /**
     * Trigger mobile fetch when pagination or debounced search changes
     */
    useEffect(() => {
        console.log('📱 [EFFECT] Mobile pagination changed:', mobilePaginationModel);
        if (isMobile) {
            fetchDataMobile();
        }
    }, [mobilePaginationModel.page, mobilePaginationModel.pageSize, isMobile, debouncedMobileSearch]);

    /**
     * Debounce mobile search and trigger fetch
     */
    useEffect(() => {
        console.log('⏱️ [DEBOUNCE] Starting 400ms timeout for:', mobileSearchQuery);

        const timer = setTimeout(() => {
            console.log('⏱️ [DEBOUNCE] Timer completed! Setting search to:', mobileSearchQuery);
            setDebouncedMobileSearch(mobileSearchQuery);
            setMobilePaginationModel({ page: 0, pageSize: 20 });
        }, 400);

        return () => {
            console.log('⏱️ [DEBOUNCE] Cleared timeout');
            clearTimeout(timer);
        };
    }, [mobileSearchQuery]);

    /**
     * Trigger desktop fetch when pagination, filters, or sort changes
     */
    useEffect(() => {
        console.log('💻 [EFFECT] Desktop dependencies changed');
        if (!isMobile) {
            fetchDataDesktop();
        }
    }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isMobile]);

    // ================= HANDLERS =================

    const handleAddCurrency = () => {
        navigate('/main/currencyMaster');
    };

    const handleEditCurrency = (row) => {
        setEditingId(row.CurrencyId);
        setOpenDialog(true);
    };

    const handleDeleteMulti = async (ids) => {
        const numericIds = ids.map(Number);
        if (!numericIds.length) return;

        setConfirmOpen(false);
        try {
            const response = await axios.post(`${API}/Delete`, {
                companyId,
                userId,
                objAryId: numericIds
            });

            console.log("Delete API response:", response);
            setSnackbar({
                open: true,
                message: 'Deleted successfully.',
                severity: 'success'
            });

            setSelectionModel([]);
            selectedIdsRef.current = [];
            setSelectAll(false);

            // Refetch data
            if (isMobile) {
                fetchDataMobile();
            } else {
                fetchDataDesktop();
            }
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;

            // 🔴 Case: 400 + referenced IDs (business rule failure)
            if (status === 400 && data?.referencedIds?.length > 0) {
                setSnackbar({
                    open: true,
                    message: "Cannot delete the selected item(s) because they are referenced in other records.",
                    severity: "warning"
                });
            } else if (status === 400 && data?.error) {
                // 🔴 400 but no referencedIds array (generic validation)
                setSnackbar({
                    open: true,
                    message: data.error,
                    severity: "warning"
                });
            } else {
                // 🔴 unexpected / server error
                setSnackbar({
                    open: true,
                    message: "Delete failed due to an unexpected error.",
                    severity: "error"
                });
            }
        }
    };

    const handleExportData = () => {
        axios({
            url: `${API}/search?mode=export&companyId=${companyId}&userId=${userId}`,
            method: 'GET',
            responseType: 'blob',
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'exportedFileCurrency.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch((error) => {
                console.error('Export error:', error);
                setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
            });
    };

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectionModel([]);
            selectedIdsRef.current = [];
            setSelectAll(false);
        } else {
            const allIds = data.map(item => item.CurrencyId);
            setSelectionModel(allIds);
            selectedIdsRef.current = allIds;
            setSelectAll(true);
        }
    };

    // ================= COLUMNS =================

    const columns = [
        {
            field: 'CurrencyName',
            headerName: 'Currency Name',
            flex: 1,
            minWidth: 150,
            renderCell: (params) => (
                <Typography
                    sx={{
                        cursor: 'pointer',
                        color: 'primary.main',
                        textDecoration: 'underline'
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleEditCurrency(params.row);
                    }}
                >
                    {params.value}
                </Typography>
            )
        },
        {
            field: 'CurrencySymbol',
            headerName: 'Symbol',
            flex: 0.5,
            minWidth: 100,
            renderCell: (params) => (
                <Typography variant="body2" color="text.secondary">
                    {params.value || '—'}
                </Typography>
            )
        },
    ];

    if (role !== "User") {
        columns.push({
            field: 'actions',
            headerName: 'Actions',
            width: 120,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const isRowSelected = selectionModel.includes(params.row.CurrencyId);
                return (
                    <Box>
                        <Tooltip
                            title={
                                isRowSelected
                                    ? "Delete selected"
                                    : "Select this row to enable delete"
                            }
                        >
                            <span>
                                <IconButton
                                    color="error"
                                    disabled={!isRowSelected}
                                    onClick={(e) => {
                                        e.stopPropagation();

                                        const idsToDelete =
                                            selectedIdsRef.current.length > 0
                                                ? selectedIdsRef.current
                                                : [params.row.CurrencyId];

                                        setPendingDeleteIds(idsToDelete);
                                        setConfirmOpen(true);
                                    }}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box>
                );
            }
        });
    }

    // ================= MOBILE CARD RENDERING =================

    const renderMobileCards = () => {
        if (loading) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            );
        }

        if (data.length === 0) {
            return <CustomNoDataOverlay />;
        }

        return (
            <>
                {data.map((row) => {
                    const isSelected = selectionModel.includes(row.CurrencyId);
                    const avatarColor = stringToColor(row.CurrencyName || 'C');
                    const initials = getInitials(row.CurrencyName);

                    return (
                        <Card key={row.CurrencyId} sx={{ mb: 1.5, borderRadius: 2, boxShadow: 1, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 3 } }}>
                            <Box sx={{ height: 5, background: `linear-gradient(90deg, ${avatarColor} 0%, ${avatarColor}88 100%)` }} />
                            <CardContent sx={{ py: 1.5, px: 1.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                    {role !== 'User' && (
                                        <Checkbox size="small" checked={isSelected} onChange={() => {
                                            const updated = isSelected
                                                ? selectionModel.filter(id => id !== row.CurrencyId)
                                                : [...selectionModel, row.CurrencyId];
                                            setSelectionModel(updated);
                                            selectedIdsRef.current = updated;
                                        }} sx={{ p: 0.5, mr: 0.5, flexShrink: 0 }} />
                                    )}
                                    <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 38, height: 38, fontWeight: 700, mr: 1.5, flexShrink: 0, fontSize: '1rem' }}>
                                        {initials}
                                    </Avatar>
                                    <Box sx={{ minWidth: 0 }}>
                                        <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => handleEditCurrency(row)}>
                                            {row.CurrencyName || '—'}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Divider sx={{ my: 0.8 }} />
                                <Box sx={{ mt: 0.8, display: 'flex', gap: 0.8, flexWrap: 'wrap' }}>
                                    {row.CurrencySymbol && <Chip color="primary" label={row.CurrencySymbol} size="small" sx={{ height: 22, fontSize: '0.75rem' }} />}
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}

                {/* Pagination */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 2,
                        py: 2
                    }}
                >
                    <Button variant="outlined" size="small" startIcon={<NavigateBeforeIcon />}
                        disabled={mobilePaginationModel.page === 0}
                        onClick={() => setMobilePaginationModel((p) => ({ ...p, page: Math.max(0, p.page - 1) }))}>
                        Previous
                    </Button>

                    <Typography variant="body2">
                        Page {mobilePaginationModel.page + 1} of{' '}
                        {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
                    </Typography>

                    <Button variant="outlined" size="small" endIcon={<NavigateNextIcon />}
                        disabled={
                            (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount
                        }
                        onClick={() =>
                            setMobilePaginationModel((p) => ({
                                ...p,
                                page: p.page + 1
                            }))
                        }
                    >
                        Next
                    </Button>
                </Box>
            </>
        );
    };

    // ================= RENDER =================

    return (
        <Box>
            {/* ── Module Header: gradient strip + title + action buttons ────────── */}
            <Box sx={{ mb: 2 }}>
                <Box sx={{ height: 4, background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)', borderRadius: '6px 6px 0 0' }} />
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderTop: 0, borderRadius: '0 0 8px 8px', px: 2, py: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                        Currencies
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {/* <Button variant="outlined" size="small" startIcon={<FaFileExcel />} onClick={handleExportData} color="success">
                            Export
                        </Button> */}
                        <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={() => { setEditingId(null); setOpenDialog(true); }}>
                            Add Currency
                        </Button>
                    </Box>
                </Paper>
            </Box>

            {data.length === 0 ? (
                <NoDataComponent />
            ) : isMobile ? (
                <>
                    {/* Mobile Search Field */}
                    <Box sx={{ mt: 1, mb: 2, px: 1 }}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Search currencies..."
                            value={mobileSearchQuery}
                            onChange={(e) => setMobileSearchQuery(e.target.value)}
                            variant="outlined"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    {/* Bulk Action Bar - Mobile Only */}
                    {role !== 'User' && selectionModel.length > 0 && (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                px: 2,
                                py: 1.5,
                                mb: 2,
                                bgcolor: 'background.paper',
                                borderRadius: 2,
                                boxShadow: 1
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
                                <Typography variant="body2" sx={{ ml: 1 }}>
                                    {selectionModel.length} selected
                                </Typography>
                            </Box>
                            <Tooltip title="Delete selected">
                                <IconButton
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        setPendingDeleteIds(selectionModel);
                                        setConfirmOpen(true);
                                    }}
                                    color="error"
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}

                    {/* Mobile Cards */}
                    <Box>{renderMobileCards()}</Box>
                </>
            ) : (
                /* Desktop DataGrid */
                <Box sx={{ height: 400 }}>
                    {data.length === 0 && !isFiltered ? (
                        <NoDataComponent />
                    ) : (
                        <CommonServerDataGrid
                            data={data}
                            columns={columns}
                            getRowId={(row) => row.CurrencyId}
                            role={role}
                            pageSizeOptions={[25, 50, 100]}
                            selectionModel={selectionModel}
                            onSelectionModelChange={setSelectionModel}
                            onPageChange={({ page, pageSize }) => {
                                setPaginationModel({ page, pageSize });
                            }}
                            onFilterChange={setFilterModel}
                            onSortChange={setSortModel}
                            rowCount={totalCount}
                            onFilterStatusChange={setIsFiltered}
                            sx={{
                                '& .MuiDataGrid-columnHeaders': { backgroundColor: '#E0E0E0' },
                                '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },
                                '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
                                '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },
                                '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
                                '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
                                '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },
                                '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },
                                '& .MuiDataGrid-cell': {
                                    display: 'flex',
                                    alignItems: 'center'
                                },
                            }}
                            slots={{
                                noResultsOverlay: CustomNoDataOverlay
                            }}
                        />
                    )}
                </Box>
            )}

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => { setSnackbar(prev => ({ ...prev, open: false })) }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => { setSnackbar(prev => ({ ...prev, open: false })) }}
                    severity={snackbar.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {/* ── Delete Confirmation Dialog ────────────────────────────────────────── */}
            <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
                <Box sx={{ height: 4, background: 'linear-gradient(90deg, #d32f2f 0%, #f44336 100%)' }} />
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>
                        Confirm Deletion
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">
                            {pendingDeleteIds.length}
                        </Typography>
                        {' '}currency record(s)? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setConfirmOpen(false)} variant="outlined" color="inherit" size="small">Cancel</Button>
                    <Button color="error" variant="contained" size="small" startIcon={<DeleteIcon />} onClick={() => handleDeleteMulti(pendingDeleteIds)}>Delete</Button>
                </Box>
            </Dialog>
            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogContent>
                    <CurrencyMaster
                        mode={editingId ? "edit" : "add"}
                        id={editingId}
                        connectionString={connectionString}
                        onPopupCancel={() => setOpenDialog(false)}
                        onSaved={() => {
                            setOpenDialog(false);

                            // 🔥 refresh list after save
                            if (isMobile) {
                                fetchDataMobile();
                            } else {
                                fetchDataDesktop();
                            }
                        }}
                    />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default CurrencyDetail2;